import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'

//REPLACED: univision_removed
export default (props) => <RedirectTemplate location={props.location} destination="/latino-es/" />

//REMOVED: univision_removed
// export default props => {
//   return (
//     <LatinoTemplateDefault
//       location={props.location}
//       lang="es"
//       market="latino"
//       video={videos.liga_mx.videoUrl}
//       staticAnnotation={videos.liga_mx.staticAnnotation}
//       title="Ve la Liga MX en vivo en TUDN"
//       subtitle={`Accede ahora por solo $${laDiscountPriceMonthly} el primer mes`}
//       tagline={'ACCEDE DESDE TU SMARTPHONE, TV, COMPUTADORA, O DESDE CUALQUIER OTRO DISPOSITIVO'}
//       networkSet="soccerLatino"
//       noteLink="/la/liga-mx/"
//       // matchtickerSportId="199"
//       // matchtickerLeagueName="Liga MX"
//       // Liga MX, La Liga, Champions League
//       // matchtickerLeagueId={['9208870', '3609994', '3616485']}
//     />
//   )
// }
